

















import Vue from 'vue'
import { CheckboxFormField } from '@/model/registration'
import { PropType } from 'vue/types/umd'

export default Vue.extend({
  name: 'CheckboxInput',
  props: {
    fieldName: {
      type: String,
      required: true
    },
    field: {
      type: Object as PropType<CheckboxFormField>,
      required: true
    }
  },
  computed: {
    inputId (): string {
      return `cbinput-${this.fieldName}`
    }
  },
  methods: {
    onInput (e: InputEvent) {
      this.$emit('input', { value: (e.target as HTMLInputElement).checked ? this.field.checkedValue : this.field.uncheckedValue })
    }
  }
})
